import React, { Component } from "react";
import * as Const from "../Data/const";

class ECODEView extends Component {
    constructor() {
        super();
    }

    componentDidMount() {
        let query = window.location.search;
        let parsed = parseQuery(query);
        //window.location.href = 'https://valid.mcheckplus.com/user/auth?id=' + parsed.c
        this.props.history.push('/user/auth?id=' + parsed.c)
        function parseQuery(search){
            let vars = search.substr(1).split('&');
            let queryString = {};
            for (let i = 0; i < vars.length; i++) {
                let pair = vars[i].split('=');
                // If first entry with this name
                if (typeof queryString[pair[0]] === 'undefined') {
                    queryString[pair[0]] = decodeURIComponent(pair[1]);
                    // If second entry with this name
                } else if (typeof queryString[pair[0]] === 'string') {
                    let arr = [queryString[pair[0]], decodeURIComponent(pair[1])];
                    queryString[pair[0]] = arr;
                    // If third or later entry with this name
                } else {
                    queryString[pair[0]].push(decodeURIComponent(pair[1]));
                }
            }
            return queryString;
        }
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

export default ECODEView